import {apiClientWithUserToken as apiClient, apiList, apiTool} from '../apiClient';
import KokudoYouto                                             from '../map/dataLayerTypes/kokudoYouto'
import Assumptionflood                                         from './dataLayerTypes/assumptionflood'
import PlanFlood                                               from './dataLayerTypes/planFlood'
import DebrisFlow                                              from './dataLayerTypes/debrisFlow'
import Collapse                                                from './dataLayerTypes/collapse'
import Landslide                                               from './dataLayerTypes/landslide'
import Tsunami                                                 from './dataLayerTypes/tsunami'
import StormSurge                                              from './dataLayerTypes/stormSurge'
import Blank                                                   from './dataLayerTypes/blank'

const DataLayer = {
  /**
   * Vue element
   */
  vueDataLayer: null,
  /**
   * Google Maps Platform
   */
  google: null,
  /**
   * 地図
   */
  map: null,
  /**
   * 以前のAPIリクエストをキャンセルするトークン
   */
  cancelToken: {
    naLayer       : null,
    dataLayer     : null,
    coordinateInfo: null,
  },
  /**
   * APIタイムアウト（ms）
   */
  API_TIMEOUT: 30000,
  COLORS     : {
    na          : '#FF4264',
    kokudo_youto: {
      1 : '#00FFFF',
      2 : '#00FFC0',
      3 : '#00FF80',
      4 : '#00FF40',
      5 : '#00FF00',
      6 : '#00C0FF',
      7 : '#00C0C0',
      8 : '#00C080',
      9 : '#007FFF',
      10: '#00C040',
      11: '#00C000',
      12: '#0080FF',
      13: '#0080C0',
      14: '#008080',
      15: '#008040',
    },
  },
  /**
   * GeoJson系の定数
   */
  GEO_JSON: {
    ZOOM       : 16, // GeoJson読み込みに切り替わるズームレベル
    CACHE_LIMIT: 20, // GeoJsonデータのキャッシュ件数
  },
  NA_TILE : {
    ZOOM: 17, // タイル画像が流用に切り替わるズームレベル
    SIZE: {
      17: 512,
      18: 1024,
      19: 2048,
      20: 4096,
      21: 8192,
      22: 16384,
    }, // タイルのサイズ（ズームレベルごと）
  },
  /**
   * GeoJsonデータ
   */
  geoJson: {
    'na'          : [],
    'kokudo_youto': [],
  },
  /**
   * GeoJsonデータのキャッシュ
   */
  geoJsonCache: [],
  /**
   * Icon for marker
   */
  icon: null,
  /**
   * Marker
   */
  marker: null,
  /**
   * Types
   */
  types                : {
    naLayer          : {
      code   : 'na',
      name   : 'NAレイヤー',
      display: true,
      tile   : {
        url    : process.env.VUE_APP_MAPTILER_URL ? process.env.VUE_APP_MAPTILER_URL : '',
        minZoom: 2,
        maxZoom: 22,
        size   : 256,
      },
    },
    kokudoYouto      : {
      code   : 'kokudo_youto',
      name   : '用途地域',
      display: false,
      tile   : null,
    },
    assumptionFlood  : {
      code   : 'assumption_flood',
      name   : '想定最大規模',
      display: false,
      tile   : {
        url            : 'https://disaportaldata.gsi.go.jp/raster/01_flood_l2_shinsuishin_data/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
    },
    planFlood        : {
      code   : 'plan_flood',
      name   : '計画規模',
      display: false,
      tile   : {
        url            : 'https://disaportaldata.gsi.go.jp/raster/01_flood_l1_shinsuishin_newlegend_data/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
    },
    collapse         : {
      code   : 'collapse',
      name   : '急傾斜地の崩壊',
      display: false,
      tile   : {
        url            : 'https://disaportaldata.gsi.go.jp/raster/05_kyukeishakeikaikuiki/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
    },
    debrisFlow       : {
      code   : 'debris_flow',
      name   : '土石流',
      display: false,
      tile   : {
        url            : 'https://disaportaldata.gsi.go.jp/raster/05_dosekiryukeikaikuiki/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
    },
    landslide        : {
      code   : 'landslide',
      name   : '地すべり',
      display: false,
      tile   : {
        url            : 'https://disaportaldata.gsi.go.jp/raster/05_jisuberikeikaikuiki/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
    },
    tsunami          : {
      code   : 'tsunami',
      name   : '津波浸水想定',
      display: false,
      tile   : {
        url            : 'https://disaportaldata.gsi.go.jp/raster/04_tsunami_newlegend_data/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 16,
        size           : 256,
      },
    },
    stormSurge       : {
      code   : 'storm_surge',
      name   : '高潮浸水想定区域',
      display: false,
      tile   : {
        url            : 'https://disaportaldata.gsi.go.jp/raster/03_hightide_l2_shinsuishin_data/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
    },
    notoSuzu         : {
      code   : 'noto_suzu',
      name   : '珠洲地区（1/2〜5）',
      display: false,
      tile   : {
        url            : [
          'https://maps.gsi.go.jp/xyz/20240102noto_suzu_0102do/{z}/{x}/{y}.png',
          'https://maps.gsi.go.jp/xyz/20240102_noto_suzu_0105do/{z}/{x}/{y}.png',
        ],
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
      center : {
        lat: 37.440741,
        lng: 137.321742,
      }
    },
    notoWajimaHigashi: {
      code   : 'noto_wajima_higashi',
      name   : '輪島東地区（1/2撮影）',
      display: false,
      tile   : {
        url            : 'https://maps.gsi.go.jp/xyz/20240102noto_wazimahigashi_0102do/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
      center : {
        lat: 37.429129,
        lng: 137.036058,
      }
    },
    notoWajimaNaka   : {
      code   : 'noto_wajima_naka',
      name   : '輪島中地区（1/2〜11）',
      display: false,
      tile   : {
        url            : [
          'https://maps.gsi.go.jp/xyz/20240102noto_wazimanaka_0102do/{z}/{x}/{y}.png',
          'https://maps.gsi.go.jp/xyz/20240102_noto_wazimanaka_0105do/{z}/{x}/{y}.png',
          'https://maps.gsi.go.jp/xyz/20240102noto_wazimanaka_0111do/{z}/{x}/{y}.png',
        ],
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
      center : {
        lat: 37.390557,
        lng: 136.899185,
      }
    },
    notoWajimaNishi  : {
      code   : 'noto_wajima_nishi',
      name   : '輪島西地区（1/11撮影）',
      display: false,
      tile   : {
        url            : 'https://maps.gsi.go.jp/xyz/20240102noto_wazimanishi_0111do/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
      center : {
        lat: 37.287490,
        lng: 136.736655,
      }
    },
    notoAnamizu      : {
      code   : 'noto_anamizu',
      name   : '穴水地区（1/5〜11）',
      display: false,
      tile   : {
        url            : [
          'https://maps.gsi.go.jp/xyz/20240102_noto_anamizu_0105do/{z}/{x}/{y}.png',
          'https://maps.gsi.go.jp/xyz/20240102noto_anamizu_0111do/{z}/{x}/{y}.png',
        ],
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
      center : {
        lat: 37.20938,
        lng: 137.049122,
      }
    },
    notoNanao        : {
      code   : 'noto_nanao',
      name   : '七尾地区（1/5撮影）',
      display: false,
      tile   : {
        url            : 'https://maps.gsi.go.jp/xyz/20240102_noto_nanao_0105do/{z}/{x}/{y}.png',
        minZoom        : 2,
        maxZoom        : 22,
        maxZoomResource: 17,
        size           : 256,
      },
      center : {
        lat: 37.048336,
        lng: 136.962229,
      }
    },
  },
  selectedDataLayerType: null,
  selectedDataLayer    : null,
  loadingCoordinateInfo: false,
  coordinateInfo       : {},
  itemInfo             : {},
  dataLayerSidebar     : false,
  /**
   * @param google
   * @param map
   */
  init(google, map) {
    this.google = google;
    this.map    = map;
    this.initGeoJson();
    this.initCoordinateInfo();
    this.initItemInfo();
    this.generateIcon();
    // オーバーレイ表示
    this.setTile();

  },
  initGeoJson() {
    this.geoJson      = {
      'na'          : [],
      'kokudo_youto': [],
    };
    this.geoJsonCache = [];
  },
  initCoordinateInfo() {
    this.coordinateInfo = {
      kokudoYouto      : {
        code: 'kokudo_youto',
        name: '用途地域',
        info: new KokudoYouto(),
      },
      assumptionflood  : {
        code: 'assumption_flood',
        name: '洪水浸水想定区域（想定最大規模）',
        info: new Assumptionflood(),
      },
      planFlood        : {
        code: 'plan_flood',
        name: '洪水浸水想定区域（計画規模）',
        info: new PlanFlood(),
      },
      collapse         : {
        code: 'collapse',
        name: '急傾斜地の崩壊',
        info: new Collapse(),
      },
      debrisFlow       : {
        code: 'debris_flow',
        name: '土石流',
        info: new DebrisFlow(),
      },
      landslide        : {
        code: 'landslide',
        name: '地すべり',
        info: new Landslide(),
      },
      tsunami          : {
        code: 'tsunami',
        name: '津波浸水想定',
        info: new Tsunami(),
      },
      stormSurge       : {
        code: 'storm_surge',
        name: '高潮浸水想定区域',
        info: new StormSurge(),
      },
      notoSuzu         : {
        code: 'noto_suzu',
        name: '珠洲地区（1/2〜5）',
        info: new Blank(),
      },
      notoWajimaHigashi: {
        code: 'noto_wajima_higashi',
        name: '輪島東地区（1/2撮影）',
        info: new Blank(),
      },
      notoWajimaNaka   : {
        code: 'noto_wajima_naka',
        name: '輪島中地区（1/2〜11）',
        info: new Blank(),
      },
      notoWajimaNishi  : {
        code: 'noto_wajima_nishi',
        name: '輪島東地区（1/11撮影）',
        info: new Blank(),
      },
      notoAnamizu      : {
        code: 'noto_anamizu',
        name: '穴水地区（1/5〜11）',
        info: new Blank(),
      },
      notoNanao        : {
        code: 'noto_nanao',
        name: '七尾地区（1/5撮影）',
        info: new Blank(),
      }
    }
  },
  initItemInfo() {
    this.itemInfo = {
      normal    : {
        tertiaryItems: {
          kokudoYouto: this.types.kokudoYouto,
        }
      },
      hazard_map: {
        flood   : {
          primaryItem  : '洪水浸水想定区域',
          tertiaryItems: {
            assumptionFlood: this.types.assumptionFlood,
            planFlood      : this.types.planFlood,
          }
        },
        sediment: {
          primaryItem  : '土砂災害警戒区域',
          tertiaryItems: {
            collapse  : this.types.collapse,
            debrisFlow: this.types.debrisFlow,
            landslide : this.types.landslide,
          }
        },
        // 令和6年能登半島地震
        notoEarthquake: {
          primaryItem  : '令和6年能登半島地震',
          tertiaryItems: {
            notoSuzu         : this.types.notoSuzu,
            notoWajimaHigashi: this.types.notoWajimaHigashi,
            notoWajimaNaka   : this.types.notoWajimaNaka,
            notoWajimaNishi  : this.types.notoWajimaNishi,
            notoAnamizu      : this.types.notoAnamizu,
            notoNanao        : this.types.notoNanao,
          }
        },
        other         : {
          tertiaryItems: {
            tsunami   : this.types.tsunami,
            stormSurge: this.types.stormSurge,
          }
        }
      },
    }
  },
  /**
   * @param vueDataLayer
   */
  setVueDataLayer(vueDataLayer) {
    this.vueDataLayer = vueDataLayer;
  },
  /**
   * @param dataLayerType
   * @return {boolean}
   */
  isNaLayer(dataLayerType) {
    return this.types.naLayer.code === dataLayerType;
  },
  /**
   * マップタイプごとに見た目を設定
   */
  setStyleForEachMapStyle: function () {
    const self = this;
    self.map.data.setStyle(feature => {
      const type = feature.getProperty('type');
      if (type !== self.types.naLayer.code) {
        const A29_004 = feature.getProperty('A29_004');
        return (
          ({
            fillColor    : this.COLORS[type][A29_004],
            fillOpacity  : 0.2,
            strokeColor  : this.COLORS[type][A29_004],
            strokeWeight : 1,
            strokeOpacity: 0.0,
            zIndex       : 1
          })
        );
      }

      // NAレイヤー
      return (
        ({
          fillColor    : this.COLORS.na,
          fillOpacity  : this.dataLayerSidebar ? 0 : 0.2,
          strokeColor  : this.COLORS.na,
          strokeWeight : 1,
          strokeOpacity: 0.0,
          zIndex       : 10
        })
      );
    });
  },
  /**
   * @return {Promise<T>}
   */
  fetchNaLayerGeoJson() {
    return this.fetchGeoJson(this.types.naLayer.code);
  },
  /**
   * @return {Promise<T>}
   */
  fetchDataLayerGeoJson() {
    const self = this;
    return new Promise((resolve, reject) => {
      if (self.selectedDataLayerType === null) {
        // Skip if has no selected type
        return resolve(null);
      }
      return self.fetchGeoJson(self.selectedDataLayerType);
    });
  },
  /**
   * 指定範囲のGeoJsonデータを取得する
   */
  fetchGeoJson: function (dataLayerType) {
    const self = this;
    return new Promise((resolve, reject) => {
      if (self.isNaLayer(dataLayerType)) {
        // NAレイヤーはタイル化したため処理しない
        return resolve(null);
      }
      if (self.geoJson[dataLayerType] === undefined || self.geoJson[dataLayerType] === null) {
        return resolve(null);
      }
      if (!this.map.getBounds()) {
        return resolve(null);
      }
      const params = Object.assign(self.getBounds(), {layer_type: dataLayerType});

      // キャッシュがヒットした場合はキャッシュを利用する
      const cache = self.searchGeoJsonCache(params);
      if (cache) {
        self.removeGeoJson(dataLayerType);
        self.geoJson[dataLayerType] = self.map.data.addGeoJson(cache);
        return resolve(null);
      }

      // 以前のリクエストが終わっていない場合はキャンセル
      if (self.cancelToken.dataLayer) {
        self.cancelToken.dataLayer.cancel();
      }
      self.cancelToken.dataLayer = apiTool.cancelToken();
      apiClient.get(apiList.jon.data_layer, {
        params     : params,
        timeout    : self.API_TIMEOUT,
        cancelToken: self.isNaLayer(dataLayerType) ? self.cancelToken.naLayer.token : self.cancelToken.dataLayer.token,
      }).then(response => {
        if (!self.isNaLayer(dataLayerType) && self.vueDataLayer === null) {
          if (!response.data.errors) {
            self.geoJsonCachePush(params, response.data);
          }
          return resolve(null);
        }
        if (!response.data.errors) {
          self.removeGeoJson(dataLayerType);
          self.geoJson[dataLayerType] = self.map.data.addGeoJson(response.data);
          self.geoJsonCachePush(params, response.data);
          return resolve(response.data);
        }
        return resolve(null);
      }).catch(error => {
        if (!apiTool.isCancel(error)) {
          console.error(dataLayerType + ' err geojson = ', error);
        }
        return reject(error);
      }).finally(() => {
        if (self.isNaLayer(dataLayerType)) {
          self.cancelToken.naLayer = null;
        } else {
          self.cancelToken.dataLayer = null;
        }
        self.setStyleForEachMapStyle();
      });
    });
  },
  /**
   * fetch coordinate information
   * @param lat
   * @param lng
   */
  fetchCoordinateInfo: function (lat = null, lng = null) {
    const self = this;
    return new Promise((resolve, reject) => {
      if (self.vueDataLayer === null) {
        return resolve(null);
      }
      const params = {
        'latitude' : lat ?? this.map.getCenter().lat(),
        'longitude': lng ?? this.map.getCenter().lng(),
      };
      self.initCoordinateInfo();
      // 以前のリクエストが終わっていない場合はキャンセル
      if (self.cancelToken.coordinateInfo) {
        self.cancelToken.coordinateInfo.cancel();
      }

      self.loadingCoordinateInfo      = true;
      this.cancelToken.coordinateInfo = apiTool.cancelToken();
      apiClient.get(apiList.jon.coordinate_info, {
        params     : params,
        timeout    : self.API_TIMEOUT,
        cancelToken: self.cancelToken.coordinateInfo.token,
      }).then(response => {
        if (self.vueDataLayer === null) {
          self.loadingCoordinateInfo = false;
          return resolve(null);
        }
        if (!response.data.errors) {
          self.parseCoordinateInfo(response.data);
          self.loadingCoordinateInfo = false;
          return resolve(response.data);
        }
        self.loadingCoordinateInfo = false;
        return resolve(null);
      }).catch(error => {
        if (!apiTool.isCancel(error)) {
          console.error('err coordinate info = ', error);
          self.loadingCoordinateInfo = false;
        }
        return reject(error);
      }).finally(() => {
        self.cancelToken.coordinateInfo = null;
      });
    });
  },
  /**
   * @param data
   */
  parseCoordinateInfo(data) {
    const self = this;
    Object.keys(self.coordinateInfo).forEach(function (dataLayerType) {
      const dataLayer = self.coordinateInfo[dataLayerType];
      if (typeof dataLayer.info.setAttributes === 'function') {
        dataLayer.info.setAttributes(data[dataLayer.code]);
      }
    });
  },
  /**
   * 地図上からGeoJsonデータを削除する
   */
  removeGeoJson: function (dataLayerType) {
    if (dataLayerType && this.geoJson[dataLayerType]) {
      for (let i = 0; i < this.geoJson[dataLayerType].length; i++) {
        this.map.data.remove(this.geoJson[dataLayerType][i]);
      }
    } else {
      const self = this;
      Object.keys(self.geoJson).forEach(function (key) {
        for (let i = 0; i < self.geoJson[key].length; i++) {
          self.map.data.remove(self.geoJson[key][i]);
        }
      })
    }
  },
  /**
   * 表示されている画面左下、右上の座標を返す
   *
   * @returns {{sw_lat: number, ne_lat: number, ne_lng: number, sw_lng: number}}
   */
  getBounds: function () {
    return {
      southwest_latitude : Math.floor(this.map.getBounds().getSouthWest().lat() * 100) / 100,
      southwest_longitude: Math.floor(this.map.getBounds().getSouthWest().lng() * 100) / 100,
      northeast_latitude : Math.ceil(this.map.getBounds().getNorthEast().lat() * 100) / 100,
      northeast_longitude: Math.ceil(this.map.getBounds().getNorthEast().lng() * 100) / 100,
    };
  },
  /**
   * 条件に一致するGeoJsonキャッシュがあるか
   *
   * @param params
   * @returns {null|*}
   */
  searchGeoJsonCache: function (params) {
    if (this.geoJsonCache.length === 0) {
      return null;
    }

    const cache = this.geoJsonCache.find(cache => {
      return cache.southwest_latitude === params.southwest_latitude
        && cache.southwest_longitude === params.southwest_longitude
        && cache.northeast_latitude === params.northeast_latitude
        && cache.northeast_longitude === params.northeast_longitude
        && cache.layer_type === params.layer_type;
    });

    return cache ? cache.data : null;
  },
  /**
   * GeoJsonデータを指定件数ほどキャッシュする
   *
   * @param params
   * @param data
   */
  geoJsonCachePush: function (params, data) {
    params.data = data;
    this.geoJsonCache.push(params);
    if (this.geoJsonCache.length > this.GEO_JSON.CACHE_LIMIT) {
      this.geoJsonCache.unshift(0);
    }
  },
  /**
   * @param dataLayerType
   */
  setSelectedDataLayerType(dataLayerType) {
    if (this.selectedDataLayerType !== null) {
      this.removeGeoJson(this.selectedDataLayerType);
    }
    this.selectedDataLayerType = dataLayerType;
    this.selectedDataLayer     = Object.values(this.types).find(type => type.code === dataLayerType);
    if (this.selectedDataLayer.center) {
      this.map.setCenter({lat: this.selectedDataLayer.center.lat, lng: this.selectedDataLayer.center.lng});
    }
    this.setZoom();
    if (!this.selectedDataLayer || !this.selectedDataLayer.tile) {
      this.removeTile();
    } else {
      this.changeTile();
    }
    this.fetchDataLayerGeoJson().then();
  },
  /**
   * Set geo json zoom
   */
  setZoom() {
    if (!this.map) {
      return;
    }
    if (this.selectedDataLayerType === null || this.selectedDataLayerType === undefined) {
      return;
    }

    // NAタイルを表示する時はズームレベルを変更しない
    if (this.selectedDataLayer.code === this.types.naLayer.code) {
      return;
    }

    const currentZoom = this.map.getZoom();
    if (this.selectedDataLayer === null
      || this.selectedDataLayer === undefined
      || this.selectedDataLayer.code === this.types.kokudoYouto.code) {
      if (currentZoom < this.GEO_JSON.ZOOM) {
        this.map.setZoom(this.GEO_JSON.ZOOM);
      }
      return;
    }
    if (currentZoom > this.selectedDataLayer.tile.maxZoom) {
      this.map.setZoom(this.selectedDataLayer.tile.maxZoom);
    }
  },
  /**
   * マーカー用のアイコンを生成
   */
  generateIcon() {
    this.icon = {
      url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
    };
  },
  /**
   * メジャー用のマーカーを生成
   *
   * @param position
   */
  setMarker(position) {
    const self = this;
    if (self.vueDataLayer === null) {
      return
    }
    self.removeMarker();

    self.marker = new self.google.maps.Marker({
      map      : self.map,
      draggable: false,
      position : position,
      icon     : self.icon,
    });
    self.fetchCoordinateInfo(position.lat(), position.lng()).then();
  },
  /**
   * Remove marker
   */
  removeMarker() {
    this.loadingCoordinateInfo = false;
    if (this.marker === null) {
      return;
    }
    this.marker.setMap(null);
    this.marker = null;
  },
  /**
   * オーバーレイ表示する
   *
   * @param url
   * @param zoom
   * @param size
   * @param zoomResource
   */
  overlayTile: function (url, zoom, size, zoomResource) {
    const self = this;
    const urls = Array.isArray(url) ? url : [url];
    urls.forEach(url => {
      const mapType = new this.google.maps.ImageMapType({
        getTileUrl: function (coords, zoom) {
          const normalizedCoord = self.getNormalizedCoord(coords, zoom);
          if (!normalizedCoord) {
            return '';
          }
          return url
            .replace('{z}', (zoomResource ? zoomResource : zoom))
            .replace('{x}', normalizedCoord.x)
            .replace('{y}', normalizedCoord.y);
        },
        tileSize  : new this.google.maps.Size(size, size),
        maxZoom   : zoom,
        minZoom   : zoom,
        opacity   : url.includes('20240102') ? 1.0 : 0.8,
      });
      this.map.overlayMapTypes.push(mapType);
    });
  },
  /**
   * 座標を正規化
   *
   * @param coord
   * @param zoom
   * @returns {{x: number, y: *}|null}
   */
  getNormalizedCoord: function (coord, zoom) {
    const tileRange = 1 << zoom;
    let y           = coord.y;
    let x           = coord.x;

    if (y < 0 || y >= tileRange) {
      return null;
    }

    if (x < 0 || x >= tileRange) {
      x = (x % tileRange + tileRange) % tileRange;
    }

    return {x: x, y: y};
  },
  /**
   * タイル画像をオーバーレイ表示
   */
  setTile: function () {
    const self = this;
    this.map.addListener('zoom_changed', function () {
      self.changeTile();
    });
    this.map.addListener('tilesloaded', function () {
      self.changeTile();
    });
  },
  /**
   * タイル切り替え
   */
  changeTile: function () {
    const zoom = this.map.getZoom();
    this.removeTile();
    if (!this.selectedDataLayer || !this.selectedDataLayer.tile) {
      this.selectedDataLayer = this.dataLayerSidebar ? null : this.types.naLayer;
    }
    if (this.selectedDataLayer === null) {
      return;
    }
    if (this.selectedDataLayer.code === this.types.naLayer.code) {
      {
        if (zoom <= 12) {
          this.overlayTile(this.selectedDataLayer.tile.url, zoom, 256);
        }
      }
    } else if (zoom >= this.selectedDataLayer.tile.minZoom && zoom <= this.selectedDataLayer.tile.maxZoom) {
      const maxZoomResource = this.selectedDataLayer.tile.maxZoomResource ?? this.selectedDataLayer.tile.maxZoom;
      let size              = this.selectedDataLayer.tile.size;
      let zoomResource      = zoom;
      if (zoom > maxZoomResource) {
        size         = size * Math.pow(2, zoom - maxZoomResource);
        zoomResource = maxZoomResource;
      }
      this.overlayTile(this.selectedDataLayer.tile.url, zoom, size, zoomResource);
    }
  },
  /**
   * 地図上からタイルデータを削除する
   */
  removeTile: function () {
    this.map.overlayMapTypes.clear();
  },
  /**
   * @param dataLayerSidebar
   */
  setDataLayerSidebar(dataLayerSidebar) {
    this.dataLayerSidebar = dataLayerSidebar;
    this.removeGeoJson();
    this.fetchNaLayerGeoJson().then();
    this.setStyleForEachMapStyle();
  },
}

export default DataLayer;
